import { createSelector } from 'reselect'

export const markersState = (state) => state.markers

export const markersSelectors = createSelector(markersState, (state) => state)
